import * as Yup from "yup";

export const schema = Yup.object().shape({
  name: Yup.string().required("Debes indicar el nombre de la categoría."),
  description: Yup.string().nullable(),
  is_unlockable: Yup.array().of(Yup.string()).nullable(),

  number_to_unlock: Yup.number()
    .nullable()
    .when("is_unlockable", {
      is: (val: string[] | undefined) => val?.includes("true"),
      then: Yup.number()
        .typeError("Debes ingresar un número.")
        .required("Debes ingresar un número.")
        .min(1, "Debe ser mayor a 0."),
      otherwise: Yup.number()
        .nullable()
        .test("empty-if-false", "Debe estar vacío si no es desbloqueable.", val => val === null || val === undefined),
    }),

  unit_to_unlock: Yup.string()
    .nullable()
    .when("is_unlockable", (isUnlockable: string[] | undefined, schema) => {
      const unlockable = isUnlockable?.includes("true");
      return unlockable
        ? Yup.string()
          .nullable()
          .required("Debes seleccionar un valor.")
        : Yup.string()
          .nullable()
          .test(
            "empty-if-false",
            "Debe estar vacío si no es una categoría bloqueada.",
            val => val === null || val === undefined
          );
    }),

  unlock_message: Yup.string()
    .nullable()
    .when("is_unlockable", {
      is: (val: string[] | undefined) => val?.includes("true"),
      then: Yup.string().required("Debes escribir un mensaje de desbloqueo."),
      otherwise: Yup.string()
        .nullable()
        .test(
          "empty-if-false",
          "Debe estar vacío si no es una categoría bloqueada.",
          val => val === null || val === undefined
        ),
    }),

  // show_before_unlock: Yup.array()
  //   .of(Yup.string())
  //   .nullable()
  //   .when("is_unlockable", {
  //     is: (val: string[] | undefined) => !val?.includes("true"),
  //     then: Yup.array()
  //       .of(Yup.string())
  //       .nullable()
  //       .test(
  //         "empty-if-false",
  //         "Debe estar vacío si no es desbloqueable.",
  //         val => val === null || val?.length === 0
  //       ),
  //   }),

  grace_period_type: Yup.string()
    .nullable()
    .when("is_unlockable", {
      is: (val: string[] | undefined) => !val?.includes("true"),
      then: Yup.string()
        .nullable()
        .test(
          "empty-if-false",
          "Debe estar vacío si no es desbloqueable.",
          val => val === null || val === undefined
        ),
    }),

  grace_period_in_days: Yup.number()
    .nullable()
    .when("grace_period_type", (grace_period_type: string, schema: Yup.NumberSchema<number | null | undefined>) => {
      if (grace_period_type === "limited") {
        return schema
          .typeError("Debe ser un número válido.")
          .required("Debes indicar la cantidad de días de gracia.")
          .min(1, "Debe ser mayor a 0.");
      } else if (grace_period_type === "forever" || grace_period_type === "none") {
        return schema
          .nullable()
          .test(
            "must-be-null",
            "No puede definirse si el tipo es 'forever' o 'none'.",
            val => val === null || val === undefined
          );
      }
      return schema;
    }),
});


export interface FormValues {
  name: string;
  description: string;
  is_unlockable: string[];
  number_to_unlock: number | null;
  unit_to_unlock: string | null;
  // show_before_unlock: string[] | null;
  unlock_message: string | null;
  grace_period_type: string | null;
  grace_period_in_days: number | null;
}

export const initialValues: FormValues = {
  name: "",
  description: "",
  is_unlockable: [],
  number_to_unlock: 30,
  unit_to_unlock: "day",
  // show_before_unlock: [],
  unlock_message: 'Felicidades! Has desbloqueado esta categoría.',
  grace_period_type: "forever",
  grace_period_in_days: 30,
};
